import * as React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { Root } from './styled';


type ChartProps = {
	config: Highcharts.Options;
	domProps?: Record<string, string>;
	afterRender?: Highcharts.ChartCallbackFunction;
};

globalThis.Highcharts = Highcharts;

const Chart: React.SFC<ChartProps> = (props) => {
	const {
		config,
		domProps,
		afterRender,
	} = props;

	return (
		<ErrorBoundary>
			<Root>
				<HighchartsReact
					highcharts={Highcharts}
					options={config}
					containerProps={domProps}
					callback={afterRender}
				/>
			</Root>
		</ErrorBoundary>
	);
}

Chart.displayName = 'Chart';
Chart.defaultProps = {};

class ErrorBoundary extends React.Component {
	state = {
		hasError: false,
	};

	static getDerivedStateFromError() {
		return { hasError: true };
	};

	render() {
		if (this.state.hasError) {
			return (
				<Root />
			);
		}

		return this.props.children;
	}
}

export default Chart;
